import { createStore } from 'vuex'
import getters from './getters'
import tagsView from './tagsView'
import ftPermissionAdmin from './modules/ftPermissionAdmin'
import app from './modules/app'
import bjftUserAdmin from './modules/bjftUserAdmin'
import dict from './modules/dict'
// 本地存储解决刷新数据小时问题
import createPersistedState from "vuex-persistedstate"

const store = createStore({
	modules: {
		app,
		tagsView,
		ftPermissionAdmin,
		bjftUserAdmin,
		dict
	},
	getters,
	plugins: [
		createPersistedState({
			// 也可以是sessionstorage
			storage: window.localStorage,
			// tagsView: tagsView,
			paths: ['tagsView', 'app', 'ftPermissionAdmin', 'bjftUserAdmin', 'dict']
		})
	]
})
export default store;
